import styled from 'styled-components';
import { color } from 'theme';
import { OVERLAY_CONFIG } from 'styles/overlayConfig';

export const ModalWrapper = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: ${OVERLAY_CONFIG.backgroundColor};
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${(props) => (props.$show ? 1 : 0)};
  transition: opacity ${OVERLAY_CONFIG.fadeInDuration}
    ${OVERLAY_CONFIG.fadeInEasing};
  pointer-events: ${(props) => (props.$show ? 'auto' : 'none')};
  z-index: 998;
`;

export const ModalContainer = styled.div.attrs({
  className: 'modal-container',
})`
  overflow: hidden;
  max-width: 600px;
  width: 96%;
  height: 480px;
  border: 2px solid
    ${(props) => props.$borderColor || props.theme.mainColor || color.red};
  border-radius: 14px;
  background: rgba(0, 0, 0, 1);
  position: relative;
  opacity: ${(props) => (props.$show ? 1 : 0)};
  transform: ${(props) => (props.$show ? 'scale(1)' : 'scale(0.95)')};
  transition:
    opacity ${OVERLAY_CONFIG.fadeInDuration} ${OVERLAY_CONFIG.fadeInEasing},
    transform ${OVERLAY_CONFIG.fadeInDuration} ${OVERLAY_CONFIG.fadeInEasing};
  visibility: ${(props) => (props.$show ? 'visible' : 'hidden')};
`;

export const InnerContainer = styled.div`
  position: absolute;
  z-index: 999;
  background: rgba(0, 0, 0, 1);
  inset: 2px;
  border-radius: 14px;
  padding: 20px 10px;
  height: calc(100% - 4px);
`;

export const ButtonWrapper = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1000;
`;
